

import apiService from '@/api/request';
import {
    ACTIVESYMBOL
} from '../mutation-type';
export const getDefaultSymbol = async ({ commit, state }) => {
    const res = await apiService.product();
    if (res.status === 1) {
      commit(ACTIVESYMBOL, res.data.productList[0]);
    }
  };
 